export enum PATHS {
  splash_screen = 'SPLASH_SCREEN',
  login = '/login',
  forgot_password = '/forgot-password',
  confirm_email = '/confirm-email',
  create_password = '/password-set',
  recovery_password = '/password-reset',
  restore = '/restore',
  select_provider = '/select-provider',
  edit = 'EDIT',
  main = '/',
  availability = '/availability',
  users = '/users',
  settings = '/settings',
  settingsCourses = '/settings/courses',
  // ТЗ 0040. Карточка курса: программа и навыки в одном месте. До неё «чему
  // учит курс» правилось в карьерном центре, а у самого курса не было и
  // перехода — таблица из трёх колонок без ссылки.
  settingsCourseDetail = '/settings/courses/:courseId',
  settingsGroups = '/settings/groups',
  settingsJournals = '/settings/journals',
  // ТЗ 0074 (доработка): настройки приостановки доступа к LMS — робот, порог,
  // шаблоны SendGrid, Slack. Видна PAYMENT_ACCESS_ROLES.
  settingsLmsAccess = '/settings/lms-access',
  profile = '/profile',
  no_shops = '/no-shops',
  dashboard = '/dashboard',
  communicator = '/communicator',
  debtors = '/debtors',
  contributions = '/debtors/contributions',
  // ТЗ 0074: «Wstrzymany dostęp» — LMS access suspensions (PAYMENT_ACCESS_ROLES).
  debtorsSuspended = '/debtors/suspended',
  debtorsPandadoc = '/debtors/pandadoc',
  debtorsPandadocProvisioning = '/debtors/pandadoc/provisioning',
  debtorsPandadocProvisioningFolder = '/debtors/pandadoc/provisioning/:folderUuid',
  journal = '/journal',
  finances = '/finances',
  financesDashboard = '/finances/dashboard',
  financesInvoices = '/finances/invoices',
  financesInvoice = '/finances/invoices/:id',
  financesExpenses = '/finances/expenses',
  financesExpense = '/finances/expenses/:id',
  financesExpenseNew = '/finances/expenses/new',
  financesPaymentCalendar = '/finances/calendar',
  financesCashFlow = '/finances/cashflow',
  // ТЗ 0075: выгрузка данных для P&L.
  financesPnl = '/finances/pnl',
  monitoring = '/monitoring',
  default = '/debtors',
  students = '/students',
  studentDetail = '/students/:id/details',
  teachers = '/teachers',
  teacherDetail = '/teachers/:id/details',
  groupDetail = '/settings/groups/:id/details',
  teachersUsers = '/teachers/users',
  teachersApplications = '/teachers/applications',
  performance = '/performance',
  zoom = '/zoom',
  zoomDashboard = '/zoom/dashboard',
  zoomLessons = '/zoom/lessons',
  zoomLesson = '/zoom/lessons/:id',
  zoomRecordings = '/zoom/recordings',
  zoomRecording = '/zoom/recordings/:id',
  zoomMatching = '/zoom/matching',
  zoomRecent = '/zoom/recent',
  zoomAccounts = '/zoom/accounts',
  zoomSchedule = '/zoom/schedule',
  zoomAudit = '/zoom/audit',
  mcpAccess = '/mcp-access',
  whiteboardLesson = '/whiteboard/lesson/:id',
  surveys = '/surveys',
  surveyNew = '/surveys/new',
  surveyTeachers = '/surveys/teachers',
  surveyAnalytics = '/surveys/analytics',
  surveyTags = '/surveys/tags',
  surveySummary = '/surveys/:id/summary',
  surveyEdit = '/surveys/:id',
  surveyResults = '/surveys/assignments/:assignmentId/results',
  careerCenter = '/career-center',
  // ТЗ 0040 фаза B. Справочник анкет: создаются здесь, прикрепляются к урокам
  // из карточки урока. Отдельный адрес, а не вкладка, — анкету заводят до
  // того, как у неё появится урок.
  careerExercises = '/dictionaries/exercises',
  // ТЗ 0040 доводка: справочник навыков и карьерные уроки переехали из вкладок
  // на свои адреса. Все шесть справочников теперь в одном доме, с общей
  // полосой переходов и одним пунктом меню.
  careerSkills = '/dictionaries/skills',
  careerLessons = '/dictionaries/lessons',
  // ТЗ 0040 фаза C. Справочники, которые до сих пор правились только в
  // Django-админке и сидами.
  careerProfessions = '/dictionaries/professions',
  careerMedals = '/dictionaries/medals',
  careerSiteCourses = '/dictionaries/site-courses',
  dofinansowanie = '/dofinansowanie',
  // ТЗ 0076: договоры с подписанием через Documenso. Ящики — в адресе:
  // `?contract=<id>`, `?contractNew=1[&group=<id>][&fromLead=<id лида>]`
  // (ТЗ 0090: форма из карточки лида), `?contractEdit=<id>`.
  contracts = '/contracts',
  // ТЗ 0078: справочник шаблонов договоров, SMS и писем.
  contractTemplates = '/contracts/templates',
  // ТЗ 0080: короткие ссылки (ручные + ссылки на подпись). Карточка — в
  // адресе: `?link=<id>`.
  shortLinks = '/short-links',
  // ТЗ 0081: SMS студентам — журнал, настройки, лестницы, шаблоны. Вкладка
  // и фильтры журнала — в адресе: `?tab=settings`, `?student=<id>&status=…`.
  sms = '/sms',
  // ТЗ 0084: лиды Kommo (воронка «New leads»). Карточка — в адресе:
  // `?lead=<id>`; фильтры — `?stage=&resp=&q=&closed=1&page=`; вкладка Admin
  // «Kommo» — `?tab=kommo`.
  leads = '/leads',
  // ТЗ 0088: маркетинговая система. Вкладка, период, фильтры и спуск по
  // разрезам — в адресе: `?tab=channels&period=90d&ch=META&path=META,123`.
  marketing = '/marketing',
  // Публичный URL: обрабатывается ДО гейта авторизации в RootRouter.
}

export function getAuthPath(path: string = '') {
  return `${path}`;
}

export enum PATHS_PARAMS {
  contributionNum = ':contributionNum',
}
